import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import HomeView from '@/views/HomeView'
import UserLoginView from '@/views/UserLoginView'
import UserProfileView from '@/views/UserProfileView'
import GiftRequestView from '@/views/GiftRequestView'
import OperationsView from '@/views/OperationsView'
import BorrowingRequestView from '@/views/BorrowingRequestView'
import ExchangeRequestView from '@/views/ExchangeRequestView'
import MessagesView from '@/views/MessagesView'
import NotificationsView from '@/views/NotificationsView'
import CoversView from '@/views/CoversView'
import UsersJoinRequests from '@/views/UsersJoinRequests'
import UploadBooks from '@/views/UploadBooks'
import ImportBooks from '@/views/ImportBooks'
import BooksView from '@/views/BooksView'
import RewardsView from '@/views/RewardsView'
import MyBooksView from '@/views/MyBooksView'
import menuHelper from "@/helpers/MenuHelper"

const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/controlPanel',
    name: 'controlPanel',
    component: OperationsView
  },
  {
    path: '/login',
    name: 'login',
    component: UserLoginView
  },
  {
    path: '/profile',
    name: 'profile',
    component: UserProfileView
  },
  {
    path: '/gift_request',
    name: 'gift_request',
    component: GiftRequestView
  },
  {
    path: '/borrowing_request',
    name: 'borrowing_request',
    component: BorrowingRequestView
  },
  {
    path: '/exchange_request',
    name: 'exchange_request',
    component: ExchangeRequestView
  },
  {
    path: '/operations',
    name: 'operations',
    component: OperationsView
  },
  {
    path: '/my_books',
    name: 'my_books',
    component: MyBooksView
  },
  {
    path: '/messages',
    name: 'messages',
    component: MessagesView
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: NotificationsView
  },
  {
    path: '/covers',
    name: 'covers',
    component: CoversView
  },
  {
    path: '/user_join_requests',
    name: 'user_join_requests',
    component: UsersJoinRequests
  },
  {
    path: '/upload_books',
    name: 'upload_books',
    component: UploadBooks
  },
  {
    path: '/import_books',
    name: 'import_books',
    component: ImportBooks
  },
  {
    path: '/books',
    name: 'books',
    component: BooksView
  },
  {
    path: '/rewards',
    name: 'rewards',
    component: RewardsView
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from) => {
  const auth = useAuthStore()
  if (isValidNavigation(auth.amIAdmin(), to.path)) {
    if ('/login' !== to.path && !auth.user.token) {
      auth.returnUrl = to.fullPath
      return '/login'
    } else if (auth.user.token && to.path === '/login') {
      return '/profile'
    } else if (to.path === '/') {
      return auth.amIAdmin() ? '/controlPanel' : '/home'
    }
  } else {
    return from
  }
})

function isValidNavigation(isAdmin, to) {
  const validNavigations = menuHelper.getNavigations(isAdmin)
  validNavigations.push('/login')
  isAdmin ? validNavigations.push('/controlPanel') : validNavigations.push('/home')
  return validNavigations.includes(to)
}

export default router
